import { render, staticRenderFns } from "./riscatta-salabam.vue?vue&type=template&id=19d76d57&"
import script from "./riscatta-salabam.vue?vue&type=script&lang=js&"
export * from "./riscatta-salabam.vue?vue&type=script&lang=js&"
import style0 from "./riscatta-salabam.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports